/* global  */ // tUrl等のグローバル変数を宣言する

// import './_form.js'

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Thumbs, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Thumbs]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
/*
 ######  ##       #### ########  ########
##       ##        ##  ##     ## ##
 ######  ##        ##  ##     ## ######
      ## ##        ##  ##     ## ##
 ######  ######## #### ########  ########
*/
if ($('.js-topMv-swiper')[0]) {
  const thumbName = '.js-topMv-thumb-swiper'
  // eslint-disable-next-line no-unused-vars
  const thumbSlide = new Swiper(thumbName, {
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 4,
    direction: 'vertical',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      // when window width is >= 640px
      769: {
        spaceBetween: 30,
        direction: 'horizontal',
      },
    },
  })

  const slideName = '.js-topMv-swiper'
  // eslint-disable-next-line no-unused-vars
  const mvSlide = new Swiper(slideName, {
    speed: 1000,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
    },
    slidesPerView: 1,
    spaceBetween: 0,
    thumbs: {
      swiper: thumbSlide,
    },
    breakpoints: {
      // when window width is >= 640px
      769: {},
    },
  })
}

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }

  $('.pQA__List dd').hide()
  $('.pQA__List dt').on('click', function () {
    $(this).next('dd').slideToggle()
    $(this).toggleClass('open')
  })

  function scrollToElement(ele) {
    if ($('.error').length > 0) {
      $('html, body').animate({ scrollTop: $(ele).offset().top - 110 }, 10)
    }
  }
  scrollToElement($('.LP__frmDownload'))

  $('select').each(function () {
    if ($(this).val() === '') {
      $(this).addClass('is-empty')
    }
  })

  $('select').on('change', function () {
    if ($(this).val() !== '') {
      $(this).removeClass('is-empty')
    } else {
      $(this).addClass('is-empty')
    }
  })
})
